import React, { useState, useEffect, useRef } from 'react';
import ApiHandler from "./../../../../../services/api/ApiHandler";
import apiPayload from './../../../../../services/api/ApiPayload';
import localStorageService from './../../../../../helpers/store/StorageService';
import CloudLoader from './../../../loader/Loader_02';

export default function ReceiveRequest({ initError, initLoader }) {
  const hasRun = useRef(false);  // Ref to track if effect has run
  let { data, loading, error, handlePostApi } = ApiHandler();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(null);

  useEffect(() => {
    if (hasRun.current) return;  // Skip if already run
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);
      setServerError(null);
      setIsSuccess(false);
      try {
        apiPayload.set('load.pageId', 'Page30010');
        apiPayload.set('load.redirectRoute', '/auth/user/receive-requests');
        apiPayload.set('load.data.userId', localStorageService.get('active', -1, 'int'));
        handlePostApi("/v1/receive-requests", apiPayload.fetchPayload());
      } catch (err) {
        setServerError({ general: 'API error', error: error });
        console.warn(err);
      } finally {
        setIsLoading(false);
      }
    }

    hasRun.current = true;  // Flag as run

    // Cleanup to prevent updates after unmount
    return () => {
      isMounted = false;
    };
    // TODO : Clear the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data && data.code === "200") {
      setIsSuccess(true);
      setPendingRequests(data.result.api_request_data.pending_requests);
    } else if (data && data.code !== "200") {
      setServerError({ general: data.result.api_request_data.error });
    }
  }, [data]);

  return (
    <>
    {initLoader && isSuccess && <CloudLoader />}
      {loading && isSuccess && <CloudLoader />}
      {isLoading && isSuccess && <CloudLoader />}
      {isSuccess && (
      <div className="static-content">
        <div className="content-section">
          <h3 className="section-important-title">Receive BTC Requests</h3>
          <br/>
          <div className="content-body">
            <p className="content-paragraph">Your Pending Receive Requests : <strong style={{ color: "rgba(72, 255, 0, 1)" }}><b>{pendingRequests}</b></strong></p>
            <br/>
            <p className="content-paragraph"><strong style={{ color: "rgb(208, 255, 0)" }}><b>Update</b></strong> : Data will be available soon</p>
          </div>
        </div>
      </div>)}
      {serverError?.general && <span className="error">{serverError.general}</span>}
      {initError && <span className="error">{initError}</span>}
    </>
  );
}
